import AddToGarage from './AddToGarage'

const AddToGarageButtonMobile = () => <AddToGarage mobile />

export default AddToGarageButtonMobile
